import React, { useState } from 'react';
import '../CSS/LoginScreen.css';
import { getBrandingValue } from '../utils/subdomainUtils';

function LoginScreen({ onLogin }) {
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [isShaking, setIsShaking] = useState(false);
  
  const logoPath = getBrandingValue('logo');
  const title = getBrandingValue('title');

  const handleSubmit = (e) => {
    e.preventDefault();
    
    if (password === 'smartbytes') {
      onLogin('user');
    } else if (password === 'smartbytesadmin') {
      onLogin('admin');
    } else {
      setError('Invalid credentials. Please try again.');
      setIsShaking(true);
      setTimeout(() => setIsShaking(false), 500);
      setPassword('');
    }
  };

  return (
    <div className="login-screen">
      <div className="login-container">
        <div className="login-card">
          <div className="login-logo-container">
            <img 
              src={logoPath} 
              alt={`${title} Logo`} 
              className="login-logo"
            />
          </div>
          
          <h1 className="login-title">{title}</h1>
          <p className="login-subtitle">Enter your password to continue</p>
          
          <form onSubmit={handleSubmit} className="login-form">
            <div className="input-wrapper">
              <input
                type="password"
                value={password}
                onChange={(e) => {
                  setPassword(e.target.value);
                  setError('');
                }}
                placeholder="Password"
                className={`login-input ${error ? 'error' : ''} ${isShaking ? 'shake' : ''}`}
                autoFocus
              />
              <svg 
                className="input-icon" 
                xmlns="http://www.w3.org/2000/svg" 
                viewBox="0 0 24 24" 
                fill="none" 
                stroke="currentColor" 
                strokeWidth="2"
              >
                <rect x="3" y="11" width="18" height="11" rx="2" ry="2"></rect>
                <path d="M7 11V7a5 5 0 0 1 10 0v4"></path>
              </svg>
            </div>
            
            {error && (
              <div className="error-message">
                <svg 
                  className="error-icon" 
                  xmlns="http://www.w3.org/2000/svg" 
                  viewBox="0 0 24 24" 
                  fill="none" 
                  stroke="currentColor" 
                  strokeWidth="2"
                >
                  <circle cx="12" cy="12" r="10"></circle>
                  <line x1="12" y1="8" x2="12" y2="12"></line>
                  <line x1="12" y1="16" x2="12.01" y2="16"></line>
                </svg>
                {error}
              </div>
            )}
            
            <button type="submit" className="login-button">
              <span>Enter</span>
              <svg 
                className="button-arrow" 
                xmlns="http://www.w3.org/2000/svg" 
                viewBox="0 0 24 24" 
                fill="none" 
                stroke="currentColor" 
                strokeWidth="2"
              >
                <line x1="5" y1="12" x2="19" y2="12"></line>
                <polyline points="12 5 19 12 12 19"></polyline>
              </svg>
            </button>
          </form>
          
          <div className="login-footer">
            <svg 
              className="security-icon" 
              xmlns="http://www.w3.org/2000/svg" 
              viewBox="0 0 24 24" 
              fill="none" 
              stroke="currentColor" 
              strokeWidth="2"
            >
              <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"></path>
            </svg>
            Secure Access
          </div>
        </div>
      </div>
    </div>
  );
}

export default LoginScreen;

